import React, {Fragment} from 'react';
import {isEmpty} from 'lodash';
import CancellationPolicies from '../CancelBooking/CancellationPolicies/CancellationPolicies';

const CancellationPolicy = (props) => {
    const {sectionTitle, policies, unstructuredPolicyFreeText} = props;

    return (
        <Fragment>
            <h3>{sectionTitle}</h3>
            {unstructuredPolicyFreeText && <p>{unstructuredPolicyFreeText}</p>}
            {!isEmpty(policies) && <CancellationPolicies policies={policies} />}
        </Fragment>
    );
};

export default CancellationPolicy;
